import {Signal} from 'signals';

class Config {
    event = {
        onFetchConfigData: new Signal(),
    };

    constructor() {
        // Use REACT_APP_ prefixed environment variables (required for Create React App)
        this.STACKRY_API_SERVER = process.env.REACT_APP_API_SERVER || "https://api.dev.stackry.com";
        this.STACKRY_API_KEY = "RsT5OjbzRn430zqMLgV3Ia"; // Default API key for reporting

        // Console URL from environment variable with fallback detection
        this.STACKRY_CONSOLE_URL = this.getConsoleUrl();
        
        // Dispatch success asynchronously (like the original PHP loading)
        setTimeout(() => {
            this.event.onFetchConfigData.dispatch({status: true, env: "static"});
        }, 100);
    }
    
    getConsoleUrl() {
        // Use REACT_APP_ prefixed environment variable
        const envConsoleUrl = process.env.REACT_APP_CONSOLE_URL;
        if (envConsoleUrl) {
            console.log('Using console URL from environment:', envConsoleUrl);
            return envConsoleUrl;
        }
        
        // Fallback: detect environment based on current hostname
        const hostname = window.location.hostname;
        console.log('No console URL env var found, detecting from hostname:', hostname);
        
        if (hostname.includes('localhost')) {
            return 'http://localhost:3001';
        } else if (hostname.includes('dev') || this.STACKRY_API_SERVER.includes('dev')) {
            return 'https://console.dev.stackry.com';
        } else if (hostname.includes('stg') || this.STACKRY_API_SERVER.includes('stg')) {
            return 'https://console.stg.stackry.com';
        } else {
            // Production
            return 'https://console.stackry.com';
        }
    }
} 

export default new Config();
